<template>
  <div class="layer-manage-wrapper">
    <div class="wrapper">
      <div class="title">
        <span>Layers</span>
        <span>图层控制</span>
        <span class="fa fa-close" @click="closePanle()"></span>
      </div>
      <div class="content">
        <div class="base-layer-ctrl">
          <span>底图切换:</span>
          <el-select v-model="selectedBaseLayer" placeholder="请选择" size="small">
            <el-option v-for="item in baseLayers" :key="item.url" :label="item.name" :value="item.url">
            </el-option>
          </el-select>
        </div>
        <el-tree default-expand-all :data="basicGeoLayers" ref="layerTree">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <div>
              <span v-show="data.children == undefined" @click="toggleShowlayer(data)" class="fa-check-sq" :class="{
                'fa fa-check-square-o': data.selected == true,
                'fa fa-square-o': data.selected == false,
              }"></span>
              <span class="layer-label">{{ data.name }}</span>
            </div>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="wrapper">
      <div class="title">
        <span>专题图层</span>
      </div>
      <div class="content">
        <el-tree default-expand-all :data="themeLayers" ref="layerTree">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <div>
              <span v-show="data.children == undefined" @click="toggleShowlayer(data)" class="fa-check-sq" :class="{
                'fa fa-check-square-o': data.selected == true,
                'fa fa-square-o': data.selected == false,
              }"></span>
              <span class="layer-label">{{ data.name }}</span>
            </div>
          </span>
        </el-tree>
      </div>
    </div>

    <!-- 图例 -->
    <div class="wrapper">
      <div class="title">
        <span>分类导航</span>
      </div>
      <div class="content">
        <div class="legend">
          <ul>
            <li v-for="(item, index) in legend" v-bind:key="index" @click="legendSelectedChanged(item)"
              v-bind:class="{ active: item.selected }">
              <span class="color" v-bind:style="{ backgroundColor: item.color.fill }"></span>
              <span>{{ item.type=='宗教寺庙'?"名刹古寺":item.type }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="title">
        <span>文物资源</span>
      </div>
      <div class="content">
        <div class="legend">
          <ul>
            <li v-for="(item, index) in relicTypeList" v-bind:key="index" @click="legendSelectedChanged(item)"
              v-bind:class="{ active: item.selected }">
              <span class="color" v-bind:style="{ backgroundColor: item.color.fill }"></span>
              <span>{{ item.title }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VectorSource from "ol/source/Vector.js";
import GeoJSON from "ol/format/GeoJSON.js";
import mentougouBianjie from "./localData/mentougou.json"; //门头沟行政区划数据
import road from "./localData/road.json";
import river from "./localData/river.json";
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from "ol/style.js";
export default {
  name: "LayerManage",
  props: {
    closeAllPanel: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      map: null,
      mapClickListenerInited: false,
      mapDialogVisible: false,
      appendToBody: true,
      selectedFeature: null,
      selectedBaseLayer: null,
      defaultType: null,
      relicTypeList: [
        {
          type: "文物资源1",
          title: "国家级",
          selected: false,
          color: { stroke: "#ccc", fill: "#07bcc7" },
        },
        {
          type: "文物资源2",
          title: "市级",
          selected: false,
          color: { stroke: "#ccc", fill: "#65c604" },
        },
        {
          type: "文物资源3",
          title: "区级",
          selected: false,
          color: { stroke: "#ccc", fill: "#c67404" },
        },
      ],
      selectedRelicType: "",
      baseLayers: [
        //1. 底图
        {
          name: "天地图影像本地瓦片",
          layer_type: "xyz",
          selected: true,
          z_index: 0,
          url: "http://114.115.221.201:8002/mtgtiles/{z}/{x}/{y}.png",
          epsg: 3857,
          min_zoom: 6,
          max_zoom: 18,
        },
        {
          name: "国家测绘局天地图影像",
          layer_type: "xyz",
          selected: true,
          z_index: 0,
          // url: "http://127.0.0.1:9004/mentougou/{z}/{y}/{x}.png",
          url: "http://t0.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=c6e9defdf18d5fac6355105b7896b7d3",
          // url: "http://t0.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=56b81006f361f6406d0e940d2f89a39c",
          // url: "http://t0.tianditu.gov.cn/img_w/wmts?tk=091388f6cf9833c84f75449378fd4886",
          epsg: 3857,
          min_zoom: 4,
          max_zoom: 18,
        },
        {
          name: "国家测绘局天地图注记",
          layer_type: "xyz",
          selected: true,
          z_index: 2,
          url: "http://t0.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=c6e9defdf18d5fac6355105b7896b7d3",
          epsg: 900913,
          min_zoom: 1,
          max_zoom: 18,
        },
        {
          name: "国家测绘局天地图地形",
          layer_type: "xyz",
          selected: true,
          z_index: 1,
          url: "http://t0.tianditu.gov.cn/DataServer?T=ter_w&x={x}&y={y}&l={z}&tk=c6e9defdf18d5fac6355105b7896b7d3",
          epsg: 900913,
          min_zoom: 1,
          max_zoom: 18,
        },
        {
          name: "腾讯矢量地图",
          layer_type: "xyz",
          selected: true,
          z_index: 0,
          // url: "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoid2FuZ2hhaGExIiwiYSI6ImNqeHUycXF5ZDEweDQzYnBiOTcwZGoxMHAifQ.eCGuiA6erHJ7ew-Fkc7dRA",
          url: "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer/tile/{z}/{y}/{x}",
          epsg: 3857,
          min_zoom: 1,
          max_zoom: 18,
        },
        {
          name: "藏蓝矢量地图",
          layer_type: "xyz",
          selected: true,
          z_index: 0,
          // url: "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoid2FuZ2hhaGExIiwiYSI6ImNqeHUycXF5ZDEweDQzYnBiOTcwZGoxMHAifQ.eCGuiA6erHJ7ew-Fkc7dRA",
          url: "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}",
          // url: "http://mt1.google.cn/vt/lyrs=m@207000000&hl=zh-CN&gl=CN&src=app&x={x}&y={y}&z={z}&s=Galile",
          epsg: 3857,
          min_zoom: 1,
          max_zoom: 18,
        },
      ],
      basicGeoLayers: [
        // 2. 基础地理数据
        {
          name: "门头沟行政区划",
          layer_type: "baseVector", // 图层类型 不要改 我们用Python写的都是返回GeoJSON数据
          islocal_data: true, // 不要改
          data: mentougouBianjie,
          selected: true, // 图层是否默认加载
          z_index: 10, // 图层叠加顺序  越大越在上面
          lable_filed: "NAME", // 图斑注记字段  填写shp 文件里的某个属性名 如果不想显示注记就配置为 null ， 矢量图才需要配
          min_zoom: 1, // 这里配置的是地图最小显示比例尺，0-18
          max_zoom: 12, // 这里配置的是地图最大显示比例尺，0-18
          lable_min_zoom: 15, // 这里配置的是该 图层注记最小显示比例尺，0-18
          lable_max_zoom: 18, // 这里配置的是该 图层注记最小显示比例尺，0-18
          setStyle: this.setBasicGeoLayersStyle, // 根据类型 设置地图颜色
        },
        {
          name: "乡镇边界",
          layer_type: "baseVector", // 图层类型 不要改 我们用Python写的都是返回GeoJSON数据
          url: "/api/gis_app/culture_xzbj_geojson/", // Python 写的接口
          asyn: true, // 不要改
          selected: true, // 图层是否默认加载
          z_index: 100, // 图层叠加顺序  越大越在上面
          lable_filed: "name", // 图斑注记字段  填写shp 文件里的某个属性名 如果不想显示注记就配置为 null ， 矢量图才需要配
          min_zoom: 9, // 这里配置的是地图最小显示比例尺，0-18
          max_zoom: 12, // 这里配置的是地图最大显示比例尺，0-18
          lable_min_zoom: 9, // 这里配置的是该 图层注记最小显示比例尺，0-18
          lable_max_zoom: 12, // 这里配置的是该 图层注记最小显示比例尺，0-18
          setStyle: this.setBasicGeoLayersStyle, // 根据类型 设置地图颜色
          isFlowerLayer: true,
          flower_layer: null
        },
        {
          name: "村边界",
          layer_type: "baseVector", // 图层类型 不要改 我们用Python写的都是返回GeoJSON数据
          url: "/api/gis_app/culture_cunjie_geojson/", // Python 写的接口
          asyn: true, // 不要改
          selected: true, // 图层是否默认加载
          z_index: 100, // 图层叠加顺序  越大越在上面
          lable_filed: "name", // 图斑注记字段  填写shp 文件里的某个属性名 如果不想显示注记就配置为 null ， 矢量图才需要配
          min_zoom: 12, // 这里配置的是地图最小显示比例尺，0-18
          max_zoom: 18, // 这里配置的是地图最大显示比例尺，0-18
          lable_min_zoom: 12, // 这里配置的是该 图层注记最小显示比例尺，0-18
          lable_max_zoom: 18, // 这里配置的是该 图层注记最小显示比例尺，0-18
          setStyle: this.setBasicGeoLayersStyle, // 根据类型 设置地图颜色
          isFlowerLayer: true,
          flower_layer: null
        },
        {
          name: "公路",
          layer_type: "baseVector", // 图层类型 不要改 我们用Python写的都是返回GeoJSON数据
          islocal_data: true, // 不要改
          data: road,
          selected: false, // 图层是否默认加载
          z_index: 100, // 图层叠加顺序  越大越在上面
          lable_filed: "name", // 图斑注记字段  填写shp 文件里的某个属性名 如果不想显示注记就配置为 null ， 矢量图才需要配
          min_zoom: 10, // 这里配置的是地图最小显示比例尺，0-18
          max_zoom: 18, // 这里配置的是地图最大显示比例尺，0-18
          lable_min_zoom: 15, // 这里配置的是该 图层注记最小显示比例尺，0-18
          lable_max_zoom: 18, // 这里配置的是该 图层注记最小显示比例尺，0-18
          setStyle: this.setBasicGeoLayersStyle, // 根据类型 设置地图颜色
        },
        {
          name: "水系",
          layer_type: "baseVector", // 图层类型 不要改 我们用Python写的都是返回GeoJSON数据
          islocal_data: true, // 不要改
          data: river,
          selected: false, // 图层是否默认加载
          z_index: 100, // 图层叠加顺序  越大越在上面
          lable_filed: "name", // 图斑注记字段  填写shp 文件里的某个属性名 如果不想显示注记就配置为 null ， 矢量图才需要配
          min_zoom: 10, // 这里配置的是地图最小显示比例尺，0-18
          max_zoom: 18, // 这里配置的是地图最大显示比例尺，0-18
          lable_min_zoom: 15, // 这里配置的是该 图层注记最小显示比例尺，0-18
          lable_max_zoom: 18, // 这里配置的是该 图层注记最小显示比例尺，0-18
          setStyle: this.setBasicGeoLayersStyle, // 根据类型 设置地图颜色
        },
      ],
      themeLayers: [
        //3. 专题地图数据
        {
          name: "文化保护区（点）", // 前端显示的图层名
          layer_type: "geoJson", // 图层类型 不要改 我们用Python写的都是返回GeoJSON数据
          url: "/api/v1/gis_app/culture_point_geojson/", // Python 写的接口
          asyn: true, // 不要改
          selected: true, // 图层是否默认加载
          z_index: 300, // 图层叠加顺序  越大越在上面
          lable_filed: "name", // 图斑注记字段  填写shp 文件里的某个属性名 如果不想显示注记就配置为 null ， 矢量图才需要配
          min_zoom: 9, // 这里配置的是地图最小显示比例尺，0-18
          max_zoom: 18, // 这里配置的是地图最大显示比例尺，0-18
          lable_min_zoom: 15, // 这里配置的是该 图层注记最小显示比例尺，0-18
          lable_max_zoom: 18, // 这里配置的是该 图层注记最小显示比例尺，0-18
          setStyle: this.setStyle, // 根据类型 设置地图颜色
          featureCollection: [],
        },
        {
          name: "文化保护区（线）",
          layer_type: "geoJson", // 图层类型 不要改 我们用Python写的都是返回GeoJSON数据
          url: "/api/gis_app/culture_line_geojson/", // Python 写的接口
          asyn: true, // 不要改
          selected: true, // 图层是否默认加载
          z_index: 200, // 图层叠加顺序  越大越在上面
          lable_filed: "name", // 图斑注记字段  填写shp 文件里的某个属性名 如果不想显示注记就配置为 null ， 矢量图才需要配
          min_zoom: 9, // 这里配置的是地图最小显示比例尺，0-18
          max_zoom: 18, // 这里配置的是地图最大显示比例尺，0-18
          lable_min_zoom: 15, // 这里配置的是该 图层注记最小显示比例尺，0-18
          lable_max_zoom: 18, // 这里配置的是该 图层注记最小显示比例尺，0-18
          setStyle: this.setStyle, // 根据类型 设置地图颜色
          featureCollection: [],
        },
        {
          name: "文化保护区（面）",
          layer_type: "geoJson", // 图层类型 不要改 我们用Python写的都是返回GeoJSON数据
          url: "/api/gis_app/culture_polygon_geojson/", // Python 写的接口
          asyn: true, // 不要改
          selected: true, // 图层是否默认加载
          z_index: 100, // 图层叠加顺序  越大越在上面
          lable_filed: "name", // 图斑注记字段  填写shp 文件里的某个属性名 如果不想显示注记就配置为 null ， 矢量图才需要配
          min_zoom: 9, // 这里配置的是地图最小显示比例尺，0-18
          max_zoom: 18, // 这里配置的是地图最大显示比例尺，0-18
          lable_min_zoom: 15, // 这里配置的是该 图层注记最小显示比例尺，0-18
          lable_max_zoom: 18, // 这里配置的是该 图层注记最小显示比例尺，0-18
          setStyle: this.setStyle, // 根据类型 设置地图颜色
          featureCollection: [],
        },
      ],
    };
  },
  watch: {
    layerFilterText(val) {
      this.$refs.layerTree.filter(val);
    },
    selectedBaseLayer() {
      this.reLoadBaseLayer();
    },
    legend: {
      handler() {
        this.legendSelectedChanged();
      },
      deep: true,
    },
    searchResultFeatureIDs() {
      let point_gids = this.searchResultFeatureIDs.point_gids;
      let line_gids = this.searchResultFeatureIDs.line_gids;
      let polygon_gids = this.searchResultFeatureIDs.polygon_gids;

      this.updateTeamlayersBySearch(point_gids, 0); //更新点图层
      this.updateTeamlayersBySearch(line_gids, 1); // 更新线图层
      this.updateTeamlayersBySearch(polygon_gids, 2); // 更新面图层
    },
  },
  computed: {
    legend() {
      return this.$store.state.legend;
    },
    searchResultFeatureIDs() {
      return this.$store.state.searchResultFeatureIDs;
    },
  },
  components: {},
  methods: {
    updateTeamlayersBySearch(feature_ids, layer_index) {
      // 根据查询结果更新图层  点 线 面图层要分开
      let searchResultFeatures = [];
      if (feature_ids == null) {
        // 关闭查询
        searchResultFeatures =
          this.themeLayers[layer_index].featureCollection.features;
      } else if (feature_ids.length == 0) {
        // 查询到0条
        searchResultFeatures = [];
      } else {
        let features = this.themeLayers[layer_index].featureCollection.features;
        // if (layer_index == 1) {
        //   debugger;
        // }

        if (features && Array.isArray(features)) {
          this.themeLayers[layer_index].featureCollection.features.forEach(
            (feature) => {
              if (feature_ids.indexOf(parseInt(feature.properties.pk)) > -1) {
                searchResultFeatures.push(feature);
              }
            }
          );
        }
      }
      let source = new VectorSource({
        crossOrigin: "anonymous",
        features: new GeoJSON().readFeatures({
          type: "FeatureCollection",
          features: searchResultFeatures,
        }),
      });
      this.themeLayers[layer_index].layer.setSource(source);
    },
    closePanle() {
      this.closeAllPanel();
    },
    setBasicGeoLayersStyle(p1, layerInfo) {
      let color = "";
      switch (layerInfo.name) {
        default:
        case "门头沟行政区划":
          color = { stroke: "#ccc", fill: "#8da3944d" };
          break;
        case "乡镇边界":
          color = { stroke: "#d9d5d5", fill: "#d9d5d500" };
          break;
        case "村边界":
          color = { stroke: "#b7b2b2", fill: "#b7b2b200" };
          break;
        case "公路":
          color = { stroke: "#e6c5a175", fill: "#e6c5a175" };
          break;
        case "水系":
          color = { stroke: "#9fd7fca8", fill: "#9fd7fca8" };
          break;
      }
      return color;
    },

    handleHover() {

      let selected = null;
      let selected_p = null;
      //   监听鼠标移动事件
      this.map.on("pointermove", (e) => {
        // console.log("e", e);
        if (selected !== null) {
          selected.setStyle(undefined);
          selected = null;
        }
        if (selected_p !== null) {
          selected_p.setStyle(undefined);
          selected_p = null;
        }
        let selectPStyle = new Style({
          fill: new Fill({
            color: "#ffffff00"
          }),
          stroke: new Stroke({
            color: "#0334fc",
            width: 2
          }),
        });
        // 检测与视口上的像素相交的要素，并对每个相交的要素执行回调。检测中包含的图层可以通过options选项中的 layerFilter 选项进行配置。
        this.map.forEachFeatureAtPixel(e.pixel, (f) => {
          if (!f.values_.legend1) {
            return
          }
          selected_p = f;
          f.setStyle(selectPStyle);
          let currentZoom = this.map.getView().getZoom();
          let scale = 0.15;
          let p_pk = f.values_.pk;

          let featureSelected;
          if(currentZoom<12){
            featureSelected = this.basicGeoLayers[1].flower_layer.getSource().getFeatures();
          }else{
            featureSelected = this.basicGeoLayers[2].flower_layer.getSource().getFeatures();
          }
          
          for (let i = 0; i < featureSelected.length; i++) {
            if ((featureSelected[i].values_.pk + "") == p_pk) {
              //点
              let featureAttrs = f.values_;
              let point_style = new Style({
                image: new Icon({
                  scale: scale,
                  img: this.xxMap.drawCanvasImg2(featureAttrs),
                  imgSize: [841.89, 595.28],
                }),
                text: new Text()
              });
              featureSelected[i].setStyle(point_style)
              selected = featureSelected[i];
            } else {
              featureSelected[i].setStyle(undefined)
            }
          }
        });

      });
    },
    setStyle(featureType, attrs) {
      let color = this.legend[0].color;
      let level = attrs.level;
      switch (featureType) {
        case this.legend[0].type:
          color = this.legend[0].color;
          break;
        case this.legend[1].type:
          color = this.legend[1].color;
          break;
        case this.legend[2].type:
          color = this.legend[2].color;
          break;
        case this.legend[3].type:
          color = this.legend[3].color;
          break;
        case this.legend[4].type:
          color = this.legend[4].color;
          break;
        case "文物资源1":
          color = { stroke: "#ccc", fill: "#07bcc7" }; // 国家级文物
          break;
        case "文物资源2":
          color = { stroke: "#ccc", fill: "#65c604" }; // 市级文物
          break;
        case "文物资源3":
          color = { stroke: "#ccc", fill: "#c67404" }; // 区级文物
          break;
        default:
          color = this.legend[5].color;
          break;
      }
      return color;
    },
    toggleShowlayer(item) {
      if (item.selected) {
        this.map.removeLayer(item.layer);
        item.selected = false;
      } else {
        this.map.addLayer(item.layer);
        item.selected = true;
      }
    },
    checkChange(node, isSelect, children) {
      this.toggleShowlayer(node, isSelect);
    },
    getFeatureGeoJSONData(current_layer) {
      this.$axios({
        url: current_layer.url,
        method: "get",
      }).then((res) => {
        let { status, message } = res.data;
        if (status === 200) {
          let layerSource = res.data.data;
          if ("featureCollection" in current_layer) {
            let defaultData = {
              type: "FeatureCollection",
              features: [],
            };
            if (this.defaultType) {
              res.data.data.features.forEach((feature) => {
                if (this.defaultType == feature.properties.type) {
                  defaultData.features.push(feature);
                }
                if (this.defaultType == "其他") {
                  if (
                    feature.properties.type == "村" ||
                    feature.properties.type == "京西煤业"
                  ) {
                    defaultData.features.push(feature);
                  }
                }
              });
              layerSource = defaultData;
            }
            current_layer.featureCollection = res.data.data;
          }

          let source = new VectorSource({
            crossOrigin: "anonymous",
            features: new GeoJSON().readFeatures(layerSource),
          });
          current_layer.layer.setSource(source);

          if (current_layer.isFlowerLayer == true) {


            this.$axios({
              url: current_layer.url,
              method: "post",
            }).then((res) => {
              let featureList = res.data.data;
              let featureCollection = {
                type: "FeatureCollection",
                features: []
              }
              featureList.forEach((f) => {
                f.geometry = JSON.parse(f.geometry)
                featureCollection.features.push({
                  "type": "Feature",
                  "geometry": f.geometry,
                  "properties": {
                    "legend1": f.legend1,
                    "legend2": f.legend2,
                    "legend3": f.legend3,
                    "legend4": f.legend4,
                    "legend5": f.legend5,
                    "legend6": f.legend6,
                    "pk": f.pk,
                  }
                })
              })
              current_layer.flower_layer.getSource().clear();
              let featureCollectionData = new GeoJSON().readFeatures(featureCollection);
              current_layer.flower_layer.getSource().addFeatures(featureCollectionData);
            })
          }
        }
      });
    },
    getFeatureLocalGeoJSONData(current_layer) {
      let source = new VectorSource({
        crossOrigin: "anonymous",
        features: new GeoJSON().readFeatures(current_layer.data),
      });
      current_layer.layer.setSource(source);
    },
    toggleLayerManage() {
      // 打开或关闭图层的函数
      this.$emit("toggleLayerManage", null);
    },
    addLayers(layers) {
      let that = this;
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].children == undefined) {
          if (layers[i].isFlowerLayer) {
            let flower_layer = this.xxMap.addFlowerLayer(layers[i]);
            flower_layer.setZIndex(500);
            layers[i].flower_layer = flower_layer;
          }

          let layer = that.xxMap.addLayer(layers[i]);
          layers[i].layer = layer;
          if (layers[i].asyn) {
            this.getFeatureGeoJSONData(layers[i]);
          }
          if (layers[i].islocal_data) {
            this.getFeatureLocalGeoJSONData(layers[i]);
          }
        } else {
          this.addLayers(layers[i].children);
        }
      }
      this.handleHover()
    },
    // 切换底图
    reLoadBaseLayer() {
      this.baseLayers.forEach((item) => {
        if (item.url != this.selectedBaseLayer) {
          if (item.layer) {
            this.map.removeLayer(item.layer);
          }
        } else {
          this.addLayers([item]);
        }
      });
    },
    updateTeamlayersByLegend(reg, layer_index) {
      // 根据图例更新图层  点 线 面图层要分开
      let selectsedFeatures = [];
      this.themeLayers[layer_index].featureCollection.features.forEach(
        (feature) => {
          if (reg.test(feature.properties.type)) {
            selectsedFeatures.push(feature);
          }
        }
      );
      let source = new VectorSource({
        crossOrigin: "anonymous",
        features: new GeoJSON().readFeatures({
          type: "FeatureCollection",
          features: selectsedFeatures,
        }),
      });
      this.themeLayers[layer_index].layer.setSource(source);
    },
    legendSelectedChanged(item) {
      if (item) {
        item.selected = !item.selected;
      }
      let selectedCultureType = [];
      this.legend.forEach((legend) => {
        if (legend.selected) {
          if (legend.type == "其他") {
            selectedCultureType.push("村");
            selectedCultureType.push("京西煤业");
          }
          selectedCultureType.push(legend.type);
        }
      });
      this.relicTypeList.forEach((relic) => {
        if (relic.selected) {
          selectedCultureType.push(relic.type);
        }
      });
      let reg = new RegExp(selectedCultureType.join("|"));
      this.updateTeamlayersByLegend(reg, 0); // 更新点图层
      this.updateTeamlayersByLegend(reg, 1); // 更新线图层
      this.updateTeamlayersByLegend(reg, 2); // 更新面图层
    },
    relicTypeChanged(item) { },
  },
  mounted() {
    this.xxMap.mapEventEmiter.$on("map-ready", (map) => {
      this.map = map;
      let google = [
        {
          name: "谷歌影像图",
          layer_type: "xyz",
          selected: true,
          z_index: 0,
          url: "/google/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}",
          epsg: 3857,
          min_zoom: 1,
          max_zoom: 7,
        },
      ];
      //0. 添加谷歌地图
      this.addLayers(google);

      //1. 添加底图
      this.selectedBaseLayer = this.baseLayers[0].url;
      //2. 添加基础地理地图
      this.addLayers(this.basicGeoLayers);
      //3. 添加专题地图
      this.addLayers(this.themeLayers);

      let arr = window.location.href.split("=");
      if (arr.length > 1) {
        this.defaultType = window.decodeURI(arr[1]);
      }
    });
  },
};
</script>
<style scoped>
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -1000px;
  width: 300px;
  line-height: 30px;
}

img {
  vertical-align: middle;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 158px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 158px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: "✖";
  color: black;
}
</style>
<style scoped lang="less" >
.layer-manage-wrapper {
  position: absolute;
  width: 300px;
  top: 0px;
  left: 45px;
  z-index: 99;
  background: #fff;
  border: solid 1px #ccc;
  padding: 10px;

  .wrapper {
    border: solid 1px #ccc;

    .title {
      background-color: #f3f8ff;
      height: 35px;
      line-height: 35px;
      padding-left: 10px;
      font-size: 15px;

      span:nth-child(1) {
        color: #355ba6;
        margin-right: 5px;
        font-weight: bold;
      }

      .fa-close {
        float: right;
        font-size: large;
        color: #9f9c9c;
        margin-top: 7px;
        margin-right: 10px;
      }

      .fa-close:hover {
        cursor: pointer;
        color: #706e6e;
      }
    }

    .content {
      padding: 10px;

      .base-layer-ctrl {
        padding-bottom: 10px;
        border-bottom: solid 1px #eee;

        span {
          margin-right: 5px;
        }

        .el-select {
          width: 190px;
        }
      }

      overflow: auto;
      height: calc(100% - 50px);

      /deep/.custom-tree-node {
        .fa {
          margin-right: 5px;
          color: rgb(6, 182, 252);
        }

        .fa-check-sq:hover {
          cursor: pointer;
          color: rgb(33, 172, 63);
        }

        .layer-label:hover {
          color: rgb(22, 140, 187);
        }

        .el-tree-node__content>.el-tree-node__expand-icon {
          padding: 0;
        }
      }
    }
  }

  .wrapper:nth-child(2) {
    margin-top: 10px;
  }

  .wrapper:nth-child(3) {
    margin-top: 10px;
  }

  .wrapper:nth-child(4) {
    margin-top: 10px;
  }
}

.legend {
  ul {
    list-style-type: none;
    padding-inline-start: 0px;

    li {
      line-height: 25px;
      display: inline-block;
      width: 33.3%;
      padding-right: 5px;

      .color {
        width: 15px;
        padding: 0px;
        height: 15px;
        border-radius: 20px;
        border: solid 1px #ccc;
        vertical-align: middle;
        display: inline-block;
        margin-right: 5px;
        margin-top: -2px;
        opacity: 0.5;
      }

      .label {
        display: inline-block;
      }
    }

    li.active {
      cursor: pointer;

      .color {
        border: solid 1px rgb(17, 17, 17);
        opacity: 1;
      }
    }
  }
}
</style>

 